import React, { Fragment } from "react";
import Header from "../header/Header";
import PatientVisits from "../patient-visits/PatientVisits";
import Patients from "../patients/Patients";
export default function DashboardResearchHRI() {
  return (
    <Fragment>
      <Header />
      <PatientVisits category={"research"} study_type="HRI_CS02" />
      <Patients category={"research"} study_type="HRI_CS02" />
    </Fragment>
  );
}
